import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function Customers() {
  const [customers, setCustomers] = useState([])
  const [search, setSearch] = useState('')
  const [levelFilter, setLevelFilter] = useState('全部')
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [showDetail, setShowDetail] = useState(null)
  const [form, setForm] = useState({ name: '', gender: '男', birth_date: '', parent_name: '', phone: '', wechat: '', level: '普通', tags: '' })

  useEffect(() => { loadCustomers() }, [])

  const loadCustomers = () => {
    setLoading(true)
    fetch(`${API}/customers`).then(r => r.json())
      .then(d => { if (d.success) setCustomers(d.data || []) })
      .finally(() => setLoading(false))
  }

  const handleCreate = () => {
    if (!form.name || !form.parent_name || !form.phone) { alert('请填写孩子姓名、家长姓名和手机号'); return }
    fetch(`${API}/customers`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form) }).then(r => r.json())
      .then(d => { if (d.success) { alert(`客户 "${form.name}" 和孩子档案创建成功！`); loadCustomers(); setShowModal(false); setForm({ name: '', gender: '男', birth_date: '', parent_name: '', phone: '', wechat: '', level: '普通', tags: '' }) } else alert('创建失败: ' + (d.error || '未知错误')) })
      .catch(() => alert('创建失败，请稍后重试'))
  }

  const filtered = customers.filter(c => {
    const matchSearch = !search || c.name.includes(search) || c.parent_name.includes(search) || c.phone.includes(search)
    const matchLevel = levelFilter === '全部' || c.level === levelFilter
    return matchSearch && matchLevel
  })

  const getLevelBadge = (level) => {
    const colors = { 'VIP': '#fa8c16', '会员': '#1890ff', '普通': '#999' }
    return <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: colors[level] || '#999', color: '#fff' }}>{level || '普通'}</span>
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ fontSize: 20, marginBottom: 4 }}>👨‍👩‍👧 客户管理</h2>
          <p style={{ color: '#666', fontSize: 13 }}>管理客户信息，录入时自动创建孩子档案</p>
        </div>
        <button onClick={() => setShowModal(true)} style={{ padding: '12px 24px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>+ 新建客户</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        {[
          { label: '客户总数', value: customers.length, color: '#1890ff' },
          { label: 'VIP客户', value: customers.filter(c => c.level === 'VIP').length, color: '#fa8c16' },
          { label: '会员客户', value: customers.filter(c => c.level === '会员').length, color: '#52c41a' },
          { label: '孩子总数', value: customers.reduce((sum, c) => sum + (c.children_count || 0), 0), color: '#722ed1' },
        ].map(s => <div key={s.label} style={card}><div style={{ color: '#999', fontSize: 12 }}>{s.label}</div><div style={{ fontSize: 28, color: s.color }}>{s.value}</div></div>)}
      </div>

      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        <input type="text" placeholder="搜索客户/家长/手机号..." value={search} onChange={e => setSearch(e.target.value)} style={{ flex: 1, maxWidth: 300, padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6 }} />
        {['全部', 'VIP', '会员', '普通'].map(l => (
          <button key={l} onClick={() => setLevelFilter(l)} style={{ padding: '8px 16px', border: 'none', borderRadius: 20, cursor: 'pointer', fontSize: 13, background: levelFilter === l ? '#1890ff' : '#f5f5f5', color: levelFilter === l ? '#fff' : '#666' }}>{l}</button>
        ))}
      </div>

      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr style={{ background: '#fafafa' }}>{['客户信息', '家长信息', '等级', '孩子', '操作'].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
          <tbody>
            {filtered.map(c => (
              <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={td}><div style={{ fontWeight: 500 }}>{c.name}</div><div style={{ fontSize: 12, color: '#999' }}>{c.phone}</div></td>
                <td style={td}><div>{c.parent_name}</div><div style={{ fontSize: 12, color: '#999' }}>{c.wechat || '-'}</div></td>
                <td style={td}>{getLevelBadge(c.level)}</td>
                <td style={td}><span style={{ color: '#722ed1', fontWeight: 500 }}>{c.children_count || 0}</span> 个孩子</td>
                <td style={td}><button onClick={() => setShowDetail(c)} style={{ ...btn, background: '#1890ff', color: '#fff' }}>查看</button></td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={5} style={{ ...td, textAlign: 'center', color: '#999', padding: 40 }}>暂无客户，点击右上角新建</td></tr>}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div style={overlay} onClick={() => setShowModal(false)}>
          <div style={modal} onClick={e => e.stopPropagation()}>
            <h3 style={{ marginBottom: 20 }}>+ 新建客户</h3>
            <p style={{ fontSize: 12, color: '#999', marginBottom: 16 }}>填写客户信息后，系统会自动创建对应的孩子档案</p>
            <div style={{ display: 'grid', gap: 16 }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div><label style={label}>孩子姓名 *</label><input value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="请输入孩子姓名" style={input} /></div>
                <div><label style={label}>性别</label><select value={form.gender} onChange={e => setForm({...form, gender: e.target.value})} style={input}><option>男</option><option>女</option></select></div>
              </div>
              <div><label style={label}>生日</label><input type="date" value={form.birth_date} onChange={e => setForm({...form, birth_date: e.target.value})} style={input} /></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div><label style={label}>家长姓名 *</label><input value={form.parent_name} onChange={e => setForm({...form, parent_name: e.target.value})} placeholder="请输入家长姓名" style={input} /></div>
                <div><label style={label}>手机号 *</label><input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} placeholder="请输入手机号" style={input} /></div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div><label style={label}>微信号</label><input value={form.wechat} onChange={e => setForm({...form, wechat: e.target.value})} placeholder="请输入微信号" style={input} /></div>
                <div><label style={label}>客户等级</label><select value={form.level} onChange={e => setForm({...form, level: e.target.value})} style={input}><option>普通</option><option>会员</option><option>VIP</option></select></div>
              </div>
              <div><label style={label}>标签（逗号分隔）</label><input value={form.tags} onChange={e => setForm({...form, tags: e.target.value})} placeholder="如：高价值、活跃" style={input} /></div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 24 }}>
              <button onClick={() => setShowModal(false)} style={{ ...btn, background: '#f5f5f5', color: '#666' }}>取消</button>
              <button onClick={handleCreate} style={{ ...btn, background: '#1890ff', color: '#fff' }}>创建</button>
            </div>
          </div>
        </div>
      )}

      {showDetail && (
        <div style={overlay} onClick={() => setShowDetail(null)}>
          <div style={{ ...modal, width: 640 }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h3>客户详情</h3>
              <button onClick={() => setShowDetail(null)} style={{ ...btn, background: '#f5f5f5' }}>关闭</button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 24 }}>
              {[{ label: '孩子姓名', value: showDetail.name }, { label: '客户等级', value: getLevelBadge(showDetail.level) }, { label: '家长姓名', value: showDetail.parent_name }, { label: '手机号', value: showDetail.phone }, { label: '微信号', value: showDetail.wechat || '-' }, { label: '孩子数量', value: (showDetail.children_count || 0) + ' 个' }].map(item => (
                <div key={item.label}><label style={label}>{item.label}</label><div style={valueStyle}>{item.value}</div></div>
              ))}
            </div>
            <div style={{ padding: 16, background: '#f6ffed', borderRadius: 8 }}>
              <h4 style={{ marginBottom: 12, color: '#52c41a' }}>📋 档案创建成功</h4>
              <p style={{ fontSize: 13, color: '#666' }}>客户录入时已自动创建：</p>
              <ul style={{ fontSize: 13, color: '#666', marginTop: 8, paddingLeft: 20 }}>
                <li>客户档案</li><li>孩子成长档案</li><li>家长关联信息</li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

const card = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
const th = { padding: 14, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 14, fontSize: 13 }
const btn = { padding: '6px 12px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }
const overlay = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }
const modal = { background: '#fff', borderRadius: 8, padding: 24, width: 480, maxHeight: '85vh', overflow: 'auto' }
const label = { display: 'block', marginBottom: 4, fontSize: 12, color: '#999' }
const input = { width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 14, boxSizing: 'border-box' }
const valueStyle = { fontSize: 14, color: '#333', padding: '8px 0' }
